import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  keyframes,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { useNavigate } from "react-router-dom";

const pulse = keyframes`
  0% { transform: scale(0.96); opacity: 0.5; }
  50% { transform: scale(1.08); opacity: 0.16; }
  100% { transform: scale(0.96); opacity: 0.5; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
`;

const turn = keyframes`
  0%, 42% { transform: rotate(0deg); }
  58%, 100% { transform: rotate(180deg); }
`;

const ComingSoon = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 180px)",
        background: `linear-gradient(145deg, ${theme.palette.background.default} 0%, ${theme.palette.primary.main}0d 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 6,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 540,
          borderRadius: 3,
          boxShadow: 5,
          textAlign: "center",
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
          <Box
            sx={{
              position: "relative",
              width: 104,
              height: 104,
              mx: "auto",
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: `${float} 2.8s ease-in-out infinite`,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                backgroundColor: `${theme.palette.primary.main}24`,
                animation: `${pulse} 2.2s ease-in-out infinite`,
              }}
            />
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: theme.palette.primary.main,
                backgroundColor: `${theme.palette.primary.main}14`,
                border: `1px solid ${theme.palette.primary.main}33`,
              }}
            >
              <HourglassEmptyIcon
                fontSize="large"
                sx={{ animation: `${turn} 2.4s ease-in-out infinite` }}
              />
            </Box>
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              mb: 1.5,
            }}
          >
            Coming Soon
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 600,
              mb: 1,
            }}
          >
            Thank you for visiting the VMS Portal.
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: theme.palette.text.secondary, mb: 3 }}
          >
            Access will be enabled soon.
          </Typography>

          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              px: 3,
            }}
            onClick={() => navigate("/")}
          >
            Back to Home
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ComingSoon;
